import { render, staticRenderFns } from "./GuardarButton.vue?vue&type=template&id=f20bcfde&scoped=true&"
import script from "./GuardarButton.vue?vue&type=script&lang=ts&"
export * from "./GuardarButton.vue?vue&type=script&lang=ts&"
import style0 from "./GuardarButton.vue?vue&type=style&index=0&id=f20bcfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20bcfde",
  null
  
)

export default component.exports